import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartPositionFieldPack: FieldPack = {
  id: 'orgchart-position',
  name: 'Position Fields',
  description: 'Position entity fields for reorg chair-moving and succession planning',
  version: '1.0.0',
  fields: [
    {
      id: 'title',
      label: 'Position Title',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 100,
      required: true,
      sensitivity: 'public',
    },
    {
      id: 'positionId',
      label: 'Position ID',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 95,
      sensitivity: 'internal',
    },
    {
      id: 'positionCode',
      label: 'Position Code',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 90,
      sensitivity: 'internal',
    },
    {
      id: 'department',
      label: 'Department',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 85,
      sensitivity: 'public',
    },
    {
      id: 'division',
      label: 'Division',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 84,
      sensitivity: 'internal',
    },
    {
      id: 'jobCode',
      label: 'Job Code',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 82,
      sensitivity: 'internal',
    },
    {
      id: 'level',
      label: 'Level',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['role'],
      priority: 80,
      sensitivity: 'public',
    },
    {
      id: 'reportsTo',
      label: 'Reports To',
      type: FieldType.TEXT,
      tags: ['organization'],
      priority: 78,
      sensitivity: 'public',
    },
    {
      id: 'jobFamily',
      label: 'Job Family',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['role'],
      priority: 75,
      sensitivity: 'public',
    },
    {
      id: 'jobProfile',
      label: 'Job Profile',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['role'],
      priority: 70,
      sensitivity: 'internal',
    },
    {
      id: 'costCenter',
      label: 'Cost Center',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 65,
      sensitivity: 'internal',
    },
    {
      id: 'location',
      label: 'Location',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization', 'location'],
      priority: 60,
      sensitivity: 'public',
    },
    {
      id: 'fte',
      label: 'FTE',
      type: FieldType.NUMBER,
      tags: ['role'],
      priority: 55,
      min: 0,
      max: 1,
      step: 0.1,
      sensitivity: 'internal',
    },
    {
      id: 'unstaffed',
      label: 'Vacant',
      type: FieldType.BOOLEAN,
      tags: ['role'],
      priority: 50,
      sensitivity: 'internal',
    },
    {
      id: 'incumbentName',
      label: 'Current Incumbent',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 45,
      sensitivity: 'internal',
    },
    {
      id: 'incumbentId',
      label: 'Incumbent ID',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 40,
      sensitivity: 'internal',
    },
    {
      id: 'payGrade',
      label: 'Pay Grade',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['compensation'],
      priority: 35,
      sensitivity: 'hr_confidential',
    },
    {
      id: 'payRangeMin',
      label: 'Pay Range Min',
      type: FieldType.NUMBER,
      tags: ['compensation'],
      priority: 30,
      min: 0,
      sensitivity: 'hr_confidential',
    },
    {
      id: 'payRangeMax',
      label: 'Pay Range Max',
      type: FieldType.NUMBER,
      tags: ['compensation'],
      priority: 25,
      min: 0,
      sensitivity: 'hr_confidential',
    },
    {
      id: 'keyPosition',
      label: 'Key Position',
      type: FieldType.BOOLEAN,
      tags: ['succession'],
      priority: 20,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'plannedFillBy',
      label: 'Planned Fill By',
      type: FieldType.DATE,
      tags: ['workforce'],
      priority: 18,
      sensitivity: 'internal',
    },
    {
      id: 'plannedStartDate',
      label: 'Planned Start Date',
      type: FieldType.DATE,
      tags: ['workforce'],
      priority: 17,
      sensitivity: 'internal',
    },
    {
      id: 'successorCount',
      label: 'Named Successors',
      type: FieldType.NUMBER,
      tags: ['succession'],
      priority: 15,
      min: 0,
      readonly: true,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'requisitionId',
      label: 'Open Requisition',
      type: FieldType.TEXT,
      tags: ['workforce'],
      priority: 10,
      sensitivity: 'internal',
    },
  ],
};
